import { render } from "./Tarifs_Course.vue?vue&type=template&id=bb610eba"
import script from "./Tarifs_Course.vue?vue&type=script&lang=js"
export * from "./Tarifs_Course.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__